/**
 * Форматирует строку телефонного номера из 71234567890 / +71234567890 в +7 123 456 78 90
 */
const PHONE_VALIDATION_REG_EX = /\+7 \(?\d\d\d\)? \d\d\d-\d\d-\d\d/;

export function formatPhoneNumber(phone?: string): string | undefined {
  if (!phone) {
    return '';
  }
  if (PHONE_VALIDATION_REG_EX.test(phone)) {
    return phone.replace(/-/g, ' ').replace(/\(/g, '').replace(/\)/g, '');
  }

  const match = phone.match(/\+?(\d{11})/);

  const mask = '+_ ___ ___ __ __';

  if (match) {
    const splittedPhone = match.slice(1, 2)[0].split('');

    return mask.replace(/_/g, () => splittedPhone.shift() || '_');
  }

  return phone;
}
